<template>
  <hgroup>
    <h1>{{heading}}</h1>
    <h2 v-if="heading2">{{heading2}}</h2>
    <h3 v-if="subheading" class="color-tint">{{subheading}}</h3>
  </hgroup>
</template>

<script>
export default {
  name: 'HeaderGroup',
  props: {
    heading: {
      type: String,
      default: 'Heading'
    },
    heading2: {
      type: String
    },
    subheading: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
  h2 {
    font-size: 2rem;
    font-weight: 400;

    h1 + & {
      position: relative;
      top: -1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// HeaderGroup.vue?4695cda7